import { render } from "./GroupMembers.vue?vue&type=template&id=98e24cdc&scoped=true"
import script from "./GroupMembers.vue?vue&type=script&lang=js"
export * from "./GroupMembers.vue?vue&type=script&lang=js"

import "./GroupMembers.vue?vue&type=style&index=0&id=98e24cdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e24cdc"]])

export default __exports__